import BrandVariableModel from "@/models/BrandVariables.model";
import { elgigantenTheme } from "@/constants/theme";

export const elgiganten: BrandVariableModel = {
  name: "Elgiganten",
  logos: {
    large: "/static/images/brands/elgiganten.svg",
    white: "/static/images/brands/elgiganten.svg",
    small: "/static/images/brands/elgiganten.svg",
    favicon:
      "/static/images/brands/elgiganten/favicon/android-chrome-512x512.png",
    alt: "Elgiganten logo",
  },
  images: {
    cover: {
      challenges: "/static/images/cover/elgiganten/challenges.webp",
    },
  },
  tenantId: "elgiganten-9u2oj",
  theme: elgigantenTheme,
  defaultLanguage: "en",
  meta: {
    title: "Elgiganten",
    description: "",
  },
  autoJoinChallenge: true,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    quickSignUp: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false,
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: true,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: false,
    feedback: false,
    events: false,
    precisionGame: true,
    schedule: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: false,
    discord: true,
    twitch: false,
  },
  hasCreate: {
    studio: false,
    challenges: false,
    news: false,
  },
};
